<div [formGroup]="form">
    <input [formControlName]="item.name" type="file" (change)="onChange($event)" [required]="item.required" multiple/>
</div>